<script>
import { back } from '@/utils/navigation'

import {
  ActionBar,
  ActionBarTitle,

} from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { CashTransferService } from '@/services'

const Filter = () => import('./Filter')
const Result = () => import('./Result')

export default {
  data() {
    const { query } = this.$route

    return {
      filter: {
        q: query.q || null,
        type: query.type || null,
        status: query.status || null,
        method: Number(query.method) || null,
        period:
          query.start && query.end
            ? [new Date(query.start), new Date(query.end)]
            : null
      },
      result: {
        items: [],
        pagination: {
          page: Number(query.page) || 1,
          total: 0,
          pageSize: 10
        },
        loading: false
      }
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    toMainPage() {
      back({ name: 'CashTransfer' })
    },

    async fetch() {
      const params = {
        search: this.filter.q || undefined,
        status: this.filter.status || ['accepted', 'cancelled'],
        is_inbound: { transfer: false, receive: true }[this.filter.type],
        datetime_after: this.filter.period ? this.filter.period[0] : undefined,
        datetime_before: this.filter.period ? this.filter.period[1] : undefined,
        payment_method: this.filter.method || undefined,
        page: this.result.pagination.page || undefined
      }

      this.result.loading = true

      try {
        const {
          data: { result }
        } = await CashTransferService.getAll(params)

        const { results, count } = result

        const getMethodName = data => {
          if (data.id === 1) return 'เงินสด'

          const bankName = data.bank ? data.bank.name : ''

          const shortId = (id => {
            if (!id) return ''

            const matches = id.match(/.{4}$/g) || id

            return matches[0]
          })(data.bank_account_id)

          return `${bankName} *${shortId}`
        }

        this.result.items = results.map(item => ({
          id: item.id,
          date: item.datetime,
          type: (inbound => {
            switch (inbound) {
              case true:
                return 'receive'

              case false:
                return 'transfer'

              default:
                return null
            }
          })(item.is_inbound),
          target: (inbound => {
            switch (inbound) {
              case true:
                return item.to_branch ? item.branch.name : null

              case false:
                return item.branch ? item.to_branch.name : null

              default:
                return null
            }
          })(item.is_inbound),
          method: (inbound => {
            switch (inbound) {
              case true:
                return item.to_branch_payment_method
                  ? getMethodName(item.to_branch_payment_method)
                  : null

              case false:
                return item.branch_payment_method
                  ? getMethodName(item.branch_payment_method)
                  : null

              default:
                return null
            }
          })(item.is_inbound),
          amount: +item.amount,
          status: item.status
        }))

        this.result.pagination.total = count
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.result.loading = false
      }
    },

    handleFilterChange(value) {
      this.filter = value
    },

    handleFilterSubmit() {
      const query = {
        q: this.filter.q || undefined,
        type: this.filter.type || undefined,
        status: this.filter.status || undefined,
        method: this.filter.method || undefined,
        start: this.filter.period
          ? this.filter.period[0].toISOString()
          : undefined,
        end: this.filter.period
          ? this.filter.period[1].toISOString()
          : undefined
      }

      this.$router.replace({ query })

      this.result.pagination.page = 1

      this.fetch()
    },

    handlePageChange(page) {
      this.result.pagination.page = page

      const query = {
        ...this.$route.query,
        page
      }

      this.$router.replace({ query })

      this.fetch()
    },

    handleView(id, type) {
      if (!id || !type) return

      this.$router.push({
        name: 'CashTransferHistoryDetail',
        params: { type, id }
      })
    }
  },

  render() {
    return (
      <div>
        <ActionBar>

          <el-button slot="action" onClick={this.toMainPage}>
            หน้ารายการปัจจุบัน
          </el-button>

          <ActionBarTitle>ประวัติการโอนเงิน</ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <Filter
              data={this.filter}
              onChange={this.handleFilterChange}
              onSubmit={this.handleFilterSubmit}
            />
            <Result
              items={this.result.items}
              pagination={this.result.pagination}
              loading={this.result.loading}
              style={{ marginTop: '1.5rem' }}
              onPageChange={this.handlePageChange}
              onView={this.handleView}
            />
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
